
import { ComputedRef, Ref, ref } from "vue";
import { authenticationUseCases } from "../../../../../domain/usecase/impl/authenticationUseCases";
import ModernInput from "./modernInput.vue";
import InputPassword from "./InputPassword.vue";
import { computed } from "@vue/reactivity";
import { dispatchErrorBox } from "../../mixins";
import { dispatchError } from "../../../utils/error_handling";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

export default {
  name: "EmailVerification",
  components: { ModernInput, InputPassword },

  setup(_) {
    const store = useStore();
    const router = useRouter();

    const password = ref("");
    const confirmation = ref("");
    const currentType = ref("password");
    const passwordPattern =
      "(?=^.{8,}$)((?=.*\\d)|(?=.*\\W+))(?![.\\n])(?=.*[A-Z])(?=.*[a-z]).*$";
    const passwordPatternTitle = ref(
      "" +
        "Sua senha deve conter: " +
        "Ao menos 8 caracteres, \n" +
        "uma letra minúscula, \n" +
        "uma letra maiúscula, \n" +
        "um caractere especial \n"
    );

    const term: Ref<boolean> = ref(false);

    async function resetPassword() {
      const token = String(router.currentRoute.value.params.token);
      const recoveryType = router.currentRoute.value.params.resetBy;
      password.value = password.value.trim();
      confirmation.value = confirmation.value.trim();
      try {
        if (!term.value) {
          await dispatchErrorBox(
            "É necessário aceitar o Termo de Uso para prosseguir!"
          );
        } else {
          if (recoveryType === "email") {
            await authenticationUseCases.resetPasswordByEmail(
              password.value,
              confirmation.value,
              token
            );
          } else {
            await authenticationUseCases.resetPasswordByData(
              password.value,
              confirmation.value,
              token
            );
          }
          //await acceptTerm();
          await store.dispatch("miscellany_module/setSuccess", {
            message: "Senha alterada com sucesso!",
            changed: true
          });
          await router.push({ name: "home" });
        }
      } catch (e) {
        await dispatchError(e);
      }
    }

    const togglePasswordVisibility = async isVisible => {
      currentType.value = isVisible ? "text" : "password";
    };

    const isPasswordVisible: ComputedRef<boolean> = computed(() => {
      return store.getters["authentication_module/isPasswordVisible"];
    });

    const acceptTerm = async (): Promise<void> => {
      await store.dispatch("authentication_module/acceptTerm");
    };
    return {
      currentType,
      password,
      confirmation,
      isPasswordVisible,
      passwordPattern,
      passwordPatternTitle,
      term,
      resetPassword,
      togglePasswordVisibility
    };
  }
};
